"use strict";
var distill;
(function (distill) {
    var dashboards;
    (function (dashboards_1) {
        var views;
        (function (views) {
            var index;
            (function (index_1) {
                class InitArgs {
                    constructor() {
                        this.dashboardsIndex = appn.emptyString;
                    }
                }
                let _initArgs;
                let _dataTable;
                let _selectedItems;
                function init(args) {
                    _initArgs = args;
                    appn.folderFilter.init(_initArgs.dashboardsIndex);
                    createDataTable();
                    addEvents();
                }
                index_1.init = init;
                function addEvents() {
                    $('#manageBtn').on('click', function (e) {
                        appn.dialog.showLoading();
                    });
                }
                function createDataTable() {
                    _dataTable = appn.dataTable.create('.dataTable', {
                        sAjaxSource: 'Dashboards/DataTable',
                        fnServerData: function (data) {
                            data.push(appn.dataTable.getStateOrDefault('sCustom_0', $('#sCustom_0').prop('checked')), { name: 'sCustom_1', value: appn.folderFilter.getStateOrDefault().value }, appn.dataTable.getStateOrDefault('sCustom_2', $('#sCustom_2').val()));
                        },
                        aaSorting: [[1, 'asc']],
                        autoWidth: false,
                        aoColumns: [
                            { bSortable: false, sWidth: '3%' },
                            { bSortable: true, sWidth: '39%' },
                            { bSortable: true, sWidth: '9%' },
                            { bSortable: true, sWidth: '4%' },
                            { bSortable: true, sWidth: '19%' },
                            { bSortable: true, sWidth: '13%' },
                            { bSortable: true, sWidth: '13%' }
                        ],
                        fnInitComplete: function () {
                            appn.actionButtons.renderNavbarActionButtons([
                                { buttonId: 'organiseBtn', buttonType: 'Organise', isDataTableToggleBtn: true },
                                { buttonId: 'manageBtn', buttonType: 'Manage', isDataTableToggleBtn: true },
                            ], appn.requestUser.isUserOrHigher, true);
                            appn.actionButtons.renderNavbarActionButtons([
                                { buttonId: 'addnew', buttonType: 'AddNew' }
                            ], appn.requestUser.isUserOrHigher);
                            appn.sideFilterAndContent.appendShowButton($('#DataTables_Table_0_filter'));
                            $('#addnew').click(function () {
                                appn.iframe.openModal({ url: 'Dashboards/Create?folderId=%0%'.replace('%0%', appn.folderFilter.selectedFolderId) });
                            });
                            $('#organiseBtn').click(function () {
                                appn.folderFilter.showDialog($(this), appn.strings.organiseScreens);
                            });
                            $('#manageBtn').on('click', function (e) {
                                e.preventDefault();
                                if ($(this).css('opacity') === '1') {
                                    _selectedItems = $('.selectRow:checked');
                                    let dashboards = appn.emptyString;
                                    _selectedItems.each(function (index, selected) {
                                        const row = selected.closest('tr');
                                        const columns = $(row).find('td');
                                        dashboards += `${$(selected).attr('id')},`;
                                    });
                                    $('#dashboardsToManage').val(dashboards);
                                    $('#manageDashboardsDialog').modal('show');
                                    const submitButton = $('#manageDashboardsDialog .card-header button[value="Manage_Trash"].btn-tool-danger');
                                    appn.trash.createTrashMessageFromTable(submitButton, _selectedItems, T('Dashboards'));
                                }
                            });
                            $('.dataTables_filter').prepend(appn.elementBuilder.buildCheckbox(appn.strings.showArchived, 'saveMeState', 'sCustom_0'));
                            appn.dataTable.addSearchPlaceholder(T('Filter results where Dashboard <b>Title, External Id or Status</b> contains a keyword typed in here.'));
                            appn.saveMeState.init(function () {
                                _dataTable.fnDraw(false);
                            }, function () {
                                _dataTable.fnDraw(false);
                            }, '.dataTables_filter');
                        }
                    });
                }
            })(index = views.index || (views.index = {}));
        })(views = dashboards_1.views || (dashboards_1.views = {}));
    })(dashboards = distill.dashboards || (distill.dashboards = {}));
})(distill || (distill = {}));
